module.exports = __webpack_public_path__ + "static/media/roller04.1312fb34.png";